import React, { createContext, useContext, useState } from "react";
import { ConfigProvider, theme as antdTheme } from "antd";
import { themes } from "./theme.config";

type ThemeContextType = {
  themeName: string;
  setThemeName: (name: string) => void;
  darkMode: boolean;
  setDarkMode: (value: boolean) => void;
};

const ThemeContext = createContext<ThemeContextType>(null!);

export const useTheme = () => useContext(ThemeContext);

export const ThemeProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [themeName, setThemeName] = useState("blue");
  const [darkMode, setDarkMode] = useState(false);

  return (
    <ThemeContext.Provider
      value={{ themeName, setThemeName, darkMode, setDarkMode }}
    >
      <ConfigProvider
        theme={{
          algorithm: darkMode
            ? antdTheme.darkAlgorithm
            : antdTheme.defaultAlgorithm,
          ...themes[themeName],
        }}
      >
        {children}
      </ConfigProvider>
    </ThemeContext.Provider>
  );
};
